
import React, { useState } from 'react'
import { Card } from 'react-bootstrap'
import KanbanTaskCard from './KanbanTaskCard';

import ToggleGroupIcon from "../AnimatedIcons/ToggleGroupIcon/ToggleGroupIcon";

interface Props {
  icon: string | JSX.Element;
  title: string;
  tasks: any[];
  className?: string;
  onSelectTask: (task_id: string) => void;
}

const KanbanColumn = (props: Props) => {

  const {
    icon,
    title,
    tasks,
    className,
    onSelectTask
  } = props

  const [ isOpen, setIsOpen ] = useState(true)

  return (
    <div className='kanban-column'>
      <Card className='kanban-column-header'
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className='kanban-column-header-title'>
          {title}
        </div>
        <div className={`kanban-column-header-icon ${className}`}>
          {icon}{' '}
          <span className="number">
            {tasks.length}
          </span>
        </div>
        <div className='kanban-column-header-arrow'>
          <ToggleGroupIcon isOpen={isOpen} size={16} />
        </div>
      </Card>
      <div className={`kanban-column-body scroller no-scroll-x ${isOpen ? '' : 'collapsed'}`}>
        {tasks.map((task: any) => (
          <KanbanTaskCard key={task._id}
            task={task}
            responsibles={task.responsibles}
            onClick={onSelectTask}
          />
        ))}
      </div>
    </div>
  )
}

export default KanbanColumn
